
























import estimatedShippingMixin from '@/product/mixins/estimatedShippingMixin'

export default estimatedShippingMixin.extend({
})
